const CONSENT_UNKNOWN = 'unknown';
const CONSENT_ACCEPTED = 'accepted';
const CONSENT_DECLINED = 'declined';

const EVENT_LEAD = Object.freeze({
  meta: 'Lead',
  ga4: 'generate_lead',
});
const EVENT_COMPLETE_REGISTRATION = Object.freeze({
  meta: 'CompleteRegistration',
  ga4: 'sign_up',
});
const EVENT_LOGIN = Object.freeze({
  meta: null,
  ga4: 'login',
});

let consent = CONSENT_UNKNOWN;
let configured = false;
let directGa4Enabled = false;
let gtmEnabled = false;
let metaEnabled = false;
let pendingEvents = [];

function dispatch(event) {
  if (consent !== CONSENT_ACCEPTED || !configured) {
    return false;
  }

  if (!event.ga4Sent) {
    if (directGa4Enabled && typeof window.gtag === 'function') {
      window.gtag('event', event.names.ga4, event.params);
      event.ga4Sent = true;
    } else if (!directGa4Enabled && gtmEnabled &&
        document.getElementById('gtm-script') && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: event.names.ga4,
        ...event.params,
      });
      event.ga4Sent = true;
    }
  }

  const shouldSendMeta = metaEnabled && !!event.names.meta;
  if (shouldSendMeta && !event.metaSent && typeof window.fbq === 'function') {
    window.fbq('track', event.names.meta);
    event.metaSent = true;
  }

  return (!(directGa4Enabled || gtmEnabled) || event.ga4Sent) &&
    (!shouldSendMeta || event.metaSent);
}

function flush() {
  if (consent !== CONSENT_ACCEPTED || !configured) {
    return;
  }

  pendingEvents = pendingEvents.filter(event => !dispatch(event));
}

function track(names, method) {
  if (consent === CONSENT_DECLINED) {
    return false;
  }

  const event = {
    names,
    params: {method},
    ga4Sent: false,
    metaSent: false,
  };

  if (dispatch(event)) {
    return true;
  }

  pendingEvents.push(event);
  return false;
}

export function configureConversionAnalytics({ga4Id, gtmId, pixelId, accepted, dismissed}) {
  configured = true;
  directGa4Enabled = typeof ga4Id === 'string' && ga4Id.length > 0;
  gtmEnabled = typeof gtmId === 'string' && gtmId.length > 0;
  metaEnabled = typeof pixelId === 'string' && pixelId.length > 0;

  if (accepted) {
    consent = CONSENT_ACCEPTED;
  } else if (dismissed) {
    consent = CONSENT_DECLINED;
    pendingEvents = [];
  }

  flush();
}

export function acceptConversionAnalytics() {
  consent = CONSENT_ACCEPTED;
  flush();
}

export function declineConversionAnalytics() {
  consent = CONSENT_DECLINED;
  pendingEvents = [];
}

export function notifyConversionTrackersReady() {
  flush();
}

export function trackRegistrationLead(method = 'email') {
  return track(EVENT_LEAD, method);
}

export function trackCompleteRegistration(method = 'email') {
  return track(EVENT_COMPLETE_REGISTRATION, method);
}

export function trackLogin(method = 'password') {
  return track(EVENT_LOGIN, method);
}
